/**
 * @class ScrollService
 */

import $ from 'jquery';

export default angular.module('cian.newbuild.scrollService', [])
.factory('ScrollService', ['$document', $document => {
  const service = {};


  // Плавный скролл
  // скроллим и html, и body для кроссбраузерности
  const $scrollBody = $($document[0].documentElement) // <html>
    .add($($document[0].body)); // <body>

  service.smoothScrollTo = pos => {
    $scrollBody.animate({ scrollTop: pos }, '500');
  };


  // Блокировка скролла

  const scrollKeys = [
    32, // пробел
    33, // pgup
    34, // pgdown
    35, // end
    36, // home

    37, // left
    38, // up
    39, // right
    40, // down
  ];

  service.disableScroll = () => {
    // Блокируем скролл мышкой/тачем
    $document.on(
      'wheel.scrollService mousewheel.scrollService touchmove.scrollService',
      e => e.preventDefault()
    );

    // Блокируем скролл кнопками
    $document.on('keydown.scrollService', e => {
      if (scrollKeys.includes(e.keyCode)) {
        e.preventDefault();
        return false;
      }
    });
  };

  service.enableScroll = () => {
    $document.off(
      'wheel.scrollService mousewheel.scrollService touchmove.scrollService keydown.scrollService'
    );
  };

  /**
   * @memberOf ScrollService
   * Позиционирует элемент по центру его родителя
   * @param {HTMLElement} htmlEl
   */
  service.scrollInParentsCenter = (htmlEl) => {
    const container = htmlEl.parentNode;
    const scrollTop = (htmlEl.offsetHeight - container.offsetHeight) / 2;
    if (scrollTop > 0) container.scrollTop = scrollTop;
  };

  return service;
}])
.name;



// WEBPACK FOOTER //
// ./src/serp/services/scroll.service.js